var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"More Arrow"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Tablet","transform":"translate(-714.000000, -350.000000)","stroke":"#FFFFFF"},React.createElement("g",{"id":"More-Arrow","transform":"translate(715.000000, 350.000000)"},[React.createElement("path",{"d":"M11.5,0 L11.5,41.2792969","id":"Line-2","strokeLinejoin":"round","key":0}),React.createElement("polyline",{"id":"Path","points":"0 30 4.18981934 34.1898193 11.5286865 41.5286865 23.057373 30","key":1})])))]);
}

ArrowDownInline.defaultProps = {"width":"25px","height":"42px","viewBox":"0 0 25 42","version":"1.1"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
